import React from 'react';
import { observer } from 'mobx-react-lite';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { NetDepositLimitConfigurationPanel } from 'src/components/DepositLimitTab/NetDepositLimit/NetDepositLimitConfigurationPanel';
import { GamstopPreviouslyPositiveState } from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositive.state';
import { GamstopPreviouslyPositiveLimitsConfigurationTooltip } from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositiveLimitsConfigurationTooltip';
import {
    GamstopPreviouslyPositiveAgeRestrictionButton,
    GamstopPreviouslyPositiveCustomLimitConfigurationActions,
    GamstopPreviouslyPositiveCustomLimitConfigurationPanels,
    GamstopPreviouslyPositiveCustomLimitConfigurationWrapper,
} from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositiveCustomLimitConfiguration.style';

interface GamstopPreviouslyPositiveCustomLimitConfigurationPropsType {
    configState: ConfigState;
    state: GamstopPreviouslyPositiveState;
}

export const GamstopPreviouslyPositiveCustomLimitConfiguration = observer(
    ({ configState, state }: GamstopPreviouslyPositiveCustomLimitConfigurationPropsType): JSX.Element => {
        return (
            <GamstopPreviouslyPositiveCustomLimitConfigurationWrapper data-test='gamstop-pp-custom-limit-configuration'>
                <GamstopPreviouslyPositiveCustomLimitConfigurationPanels>
                    <NetDepositLimitConfigurationPanel
                        ageGroupLabel={state.isAgeRestrictedLimitsEnabled ? 'Over 25' : undefined}
                        configState={configState}
                        dataTestSuffix={state.isAgeRestrictedLimitsEnabled ? 'over-25' : undefined}
                        showDescription={!state.isAgeRestrictedLimitsEnabled}
                        state={state.limitConfigurationState}
                        titleTooltip={<GamstopPreviouslyPositiveLimitsConfigurationTooltip />}
                    />

                    {state.isAgeRestrictedLimitsEnabled ? (
                        <NetDepositLimitConfigurationPanel
                            ageGroupLabel='Under 25'
                            configState={configState}
                            dataTestSuffix='under-25'
                            showDescription={false}
                            state={state.limitConfigurationStateUnder25}
                            titleTooltip={<GamstopPreviouslyPositiveLimitsConfigurationTooltip />}
                        />
                    ) : null}
                </GamstopPreviouslyPositiveCustomLimitConfigurationPanels>

                <GamstopPreviouslyPositiveCustomLimitConfigurationActions>
                    {state.isAgeRestrictedLimitsEnabled ? (
                        <GamstopPreviouslyPositiveAgeRestrictionButton
                            data-test='gamstop-pp-disable-age-restricted-limits'
                            onClick={state.disableAgeRestrictedLimits}
                            type='button'
                        >
                            Back to single limit configuration
                        </GamstopPreviouslyPositiveAgeRestrictionButton>
                    ) : (
                        <GamstopPreviouslyPositiveAgeRestrictionButton
                            data-test='gamstop-pp-enable-age-restricted-limits'
                            onClick={state.enableAgeRestrictedLimits}
                            type='button'
                        >
                            Do you want to make the limits age-restricted over 25 years old and under 25 years old?
                        </GamstopPreviouslyPositiveAgeRestrictionButton>
                    )}
                </GamstopPreviouslyPositiveCustomLimitConfigurationActions>
            </GamstopPreviouslyPositiveCustomLimitConfigurationWrapper>
        );
    }
);
